module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "12"
    }
  }, [_c('b-card', {
    staticClass: "formCardDash"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Quotations")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Total Amount: " + _vm._s(_vm.formatCurrency(_vm.totalQuotationAmount)) + " | Total Records: " + _vm._s(_vm.totalRecords))])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Search by quotation no, client name...",
      "size": "sm"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [10, 25, 50, 100],
      "size": "sm"
    },
    on: {
      "change": _vm.updatePagination
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-info",
      "size": "sm",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.refreshData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    class: {
      'fa-spin': _vm.isLoading
    }
  }), _vm._v("\n            Refresh\n          ")])], 1)], 1), _vm._v(" "), _c('b-table', {
    staticClass: "mb-0",
    attrs: {
      "items": _vm.quotationsData,
      "fields": _vm.fields,
      "busy": _vm.isLoading,
      "striped": "",
      "bordered": "",
      "hover": "",
      "small": "",
      "show-empty": "",
      "empty-text": "No quotation data found"
    },
    scopedSlots: _vm._u([{
      key: "quotationNumber",
      fn: function(data) {
        return [_c('code', [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "createdAt",
      fn: function(data) {
        return [_vm._v("\n          " + _vm._s(_vm.formatDate(data.value)) + "\n        ")]
      }
    }, {
      key: "quotationType",
      fn: function(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.getQuotationTypeVariant(data.value)
          }
        }, [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "status",
      fn: function(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.getStatusVariant(data.value)
          }
        }, [_vm._v(_vm._s(_vm.getStatusText(data.value)))])]
      }
    }, {
      key: "clientName",
      fn: function(data) {
        return [_c('strong', [_vm._v(_vm._s(data.value || 'Unknown'))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(data.item.EnqNo || '-'))])]
      }
    }, {
      key: "POL",
      fn: function(data) {
        return [_c('small', [_vm._v(_vm._s(data.value) + " → " + _vm._s(data.item.POD))])]
      }
    }, {
      key: "totalAmount",
      fn: function(data) {
        return [_c('strong', {
          staticClass: "text-right d-block"
        }, [_vm._v(_vm._s(_vm.formatCurrency(data.value)))])]
      }
    }, {
      key: "actions",
      fn: function(data) {
        return [_c('b-button', {
          staticClass: "toggle-btn",
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.toggleDetails(data.item)
            }
          }
        }, [_c('i', {
          class: data.item._showDetails ? 'fa fa-chevron-up' : 'fa fa-chevron-down'
        })])]
      }
    }, {
      key: "row-details",
      fn: function(row) {
        return [_c('div', {
          staticClass: "row-details"
        }, [_c('div', {
          staticClass: "row mb-3"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "card border-primary"
        }, [_c('div', {
          staticClass: "card-header bg-primary text-white"
        }, [_c('i', {
          staticClass: "fa fa-file-text"
        }), _vm._v(" Quotation Details\n                  ")]), _vm._v(" "), _c('div', {
          staticClass: "card-body"
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Quotation No:")]), _vm._v(" " + _vm._s(row.item.quotationNumber) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Type:")]), _vm._v(" " + _vm._s(row.item.quotationType) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Status:")]), _vm._v(" " + _vm._s(_vm.getStatusText(row.item.status)) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Created Date:")]), _vm._v(" " + _vm._s(_vm.formatDate(row.item.createdAt)) + "\n                      ")])]), _vm._v(" "), _c('div', {
          staticClass: "row mt-2"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Buying Rate:")]), _vm._v(" " + _vm._s(_vm.formatCurrency(row.item.buyingRate)) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Selling Rate:")]), _vm._v(" " + _vm._s(_vm.formatCurrency(row.item.sellingRate)) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Total Amount:")]), _vm._v(" " + _vm._s(_vm.formatCurrency(row.item.totalAmount)) + "\n                      ")]), _vm._v(" "), (row.item.ffType) ? _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("FF Type:")]), _vm._v(" " + _vm._s(row.item.ffType) + "\n                      ")]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
          staticClass: "row mb-3"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "card border-success"
        }, [_c('div', {
          staticClass: "card-header bg-success text-white"
        }, [_c('i', {
          staticClass: "fa fa-map-marker"
        }), _vm._v(" Location Details\n                  ")]), _vm._v(" "), _c('div', {
          staticClass: "card-body"
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("POR:")]), _vm._v(" " + _vm._s(row.item.POR || row.item.porLocation || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("POL:")]), _vm._v(" " + _vm._s(row.item.POL || row.item.polLocation || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("POD:")]), _vm._v(" " + _vm._s(row.item.POD || row.item.podLocation || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("FPOD:")]), _vm._v(" " + _vm._s(row.item.FPOD || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("Stuffing:")]), _vm._v(" " + _vm._s(row.item.STUFF || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("Handover:")]), _vm._v(" " + _vm._s(row.item.HAND || '-') + "\n                      ")])])])])])]), _vm._v(" "), _c('div', {
          staticClass: "row mb-3"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "card border-warning"
        }, [_c('div', {
          staticClass: "card-header bg-warning"
        }, [_c('i', {
          staticClass: "fa fa-users"
        }), _vm._v(" Client & Enquiry Details\n                  ")]), _vm._v(" "), _c('div', {
          staticClass: "card-body"
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Main Client:")]), _vm._v(" " + _vm._s(row.item.ClientName || row.item.clientName || 'Unknown') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Exporter:")]), _vm._v(" " + _vm._s(row.item.ExpClientName || row.item.exporterClientName || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Importer:")]), _vm._v(" " + _vm._s(row.item.ImpClientName || row.item.importerClientName || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Enquiry:")]), _vm._v(" " + _vm._s(row.item.EnqNo || row.item.enquirySeries || '-') + "\n                      ")])]), _vm._v(" "), _c('div', {
          staticClass: "row mt-2"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Enquiry Date:")]), _vm._v(" " + _vm._s(_vm.formatDate(row.item.EnqDate || row.item.enquiryDate)) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Job Type:")]), _vm._v(" " + _vm._s(row.item.jobType || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Transport Type:")]), _vm._v(" " + _vm._s(row.item.transportType || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Shipping Line:")]), _vm._v(" " + _vm._s(row.item.SlineName || row.item.shippingLine || '-') + "\n                      ")])])])])])]), _vm._v(" "), _c('div', {
          staticClass: "row mb-3"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "card border-info"
        }, [_c('div', {
          staticClass: "card-header bg-info text-white"
        }, [_c('i', {
          staticClass: "fa fa-tags"
        }), _vm._v(" Quotation Series\n                  ")]), _vm._v(" "), _c('div', {
          staticClass: "card-body"
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Regular:")]), _vm._v(" " + _vm._s(row.item.quotationSeries || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("CC:")]), _vm._v(" " + _vm._s(row.item.ccQSeries || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("FF:")]), _vm._v(" " + _vm._s(row.item.ffQSeries || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("TPT:")]), _vm._v(" " + _vm._s(row.item.tptQSeries || '-') + "\n                      ")])])])])])])])]
      }
    }])
  }, [_c('template', {
    slot: "table-busy"
  }, [_c('div', {
    staticClass: "text-center text-danger my-2"
  }, [_c('b-spinner', {
    staticClass: "align-middle",
    attrs: {
      "small": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "ml-2"
  }, [_vm._v("Loading...")])], 1)])], 2), _vm._v(" "), (_vm.totalItems > _vm.pagination.perPage) ? _c('b-pagination', {
    staticClass: "mt-3",
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalItems
    },
    on: {
      "change": _vm.onPageChange
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-2 d-flex justify-content-between align-items-center"
  }, [_c('div', [_c('b-form-select', {
    staticClass: "w-auto",
    attrs: {
      "options": _vm.pagination.pageOptions,
      "size": "sm"
    },
    on: {
      "change": _vm.updatePagination
    },
    model: {
      value: (_vm.pagination.perPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "perPage", $$v)
      },
      expression: "pagination.perPage"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-muted"
  }, [_vm._v("per page")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-muted small"
  }, [_vm._v("\n          Total Records: " + _vm._s(_vm.totalItems) + " | Total Amount: " + _vm._s(_vm.formatCurrency(_vm.totalQuotationAmount)) + "\n        ")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3cdca52","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/salesPersonDashboard/QuotationsSection.vue
// module id = 2867
// module chunks = 0